import { CheckboxItem } from '../../../Checkboxes/CheckboxItem';

export interface FaultTextProps {
  title?: string;
  faultText?: string | string[];
}

const FaultText = (props: Pick<FaultTextProps, 'faultText'>) => {
  if (!props.faultText) {
    return null;
  }

  if (Array.isArray(props.faultText)) {
    return (
      <div className="flex h-full w-full flex-col gap-3.5">
        <div className="flex h-full w-full flex-col gap-3.5 py-10">
          {props.faultText.map((text, idx) => {
            return <CheckboxItem key={idx} text={text} defaultChecked checked />;
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col gap-3.5">
      <div className="flex h-full w-full flex-col gap-3.5 py-10">
        <CheckboxItem text={props.faultText} defaultChecked checked />
      </div>
    </div>
  );
};

export const FaultTextPresenter = (props: FaultTextProps) => {
  const { title, faultText } = props;

  return (
    <div className='c-fault-text-presenter'>
      {title && (
        <div>
          <h3 className="pb-2 text-xl font-bold text-black dark:text-white sm:text-xl 2xl:text-2xl">{title}</h3>
          <span className="mx-auto mb-6 inline-block h-1 w-22.5 rounded bg-primary"></span>
        </div>
      )}
      {faultText && (
        <div className="flex-auto">
          <FaultText faultText={faultText} />
        </div>
      )}
    </div>
  );
};
